export type EmailLogStatus =
  | "QUEUED"
  | "SENT"
  | "DELIVERED"
  | "OPENED"
  | "CLICKED"
  | "BOUNCED"
  | "DROPPED"
  | "DEFERRED"
  | "SPAM_REPORT"
  | "FAILED"
  | string;

export type EmailLogSortBy =
  | "createdAt"
  | "sentAt"
  | "deliveredAt"
  | "status"
  | "recipient";

export interface EmailLogRecipient {
  email?: string;
  name?: string;
  [key: string]: unknown;
}

export interface EmailLog {
  id: number;
  emailLogId: string;
  recipient: string;
  recipientCount?: number;
  recipientsJson?: EmailLogRecipient[] | null;
  fromEmail?: string | null;
  fromName?: string | null;
  subject?: string | null;
  templateId?: string | null;
  templateName?: string | null;
  templateData?: Record<string, unknown> | null;
  bodyHash?: string | null;
  provider?: string | null;
  sendgridMessageId?: string | null;
  status: EmailLogStatus;
  statusCode?: number | null;
  referenceType?: string | null;
  referenceId?: string | null;
  sentAt?: string | null;
  deliveredAt?: string | null;
  openedAt?: string | null;
  createdAt?: string | null;
  [key: string]: unknown;
}

export interface EmailLogEvent {
  id: number;
  emailLogId: string;
  event: string;
  eventTimestamp?: string | null;
  response?: string | null;
  ip?: string | null;
  userAgent?: string | null;
  [key: string]: unknown;
}

export interface EmailLogsPagination {
  page: number;
  limit: number;
  totalRecords: number;
  totalPages: number;
}

export interface EmailLogsListParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  templateName?: string;
  templateId?: string;
  referenceType?: string;
  referenceId?: string;
  recipient?: string;
  fromEmail?: string;
  fromDate?: string;
  toDate?: string;
  sortBy?: EmailLogSortBy;
  sortOrder?: "ASC" | "DESC";
}

export interface EmailLogsListResponse {
  success?: boolean;
  msg: string;
  data: {
    logs: EmailLog[];
    pagination: EmailLogsPagination;
  };
}

export interface EmailLogStatsSummary {
  total: number;
  statusCounts: Record<string, number>;
}

export interface EmailLogStatsResponse {
  success?: boolean;
  msg: string;
  data: EmailLogStatsSummary;
}

export interface EmailLogDetailsResponse {
  success?: boolean;
  msg: string;
  data: {
    emailLog: EmailLog;
    events: EmailLogEvent[];
  };
}

export const EMAIL_LOG_STATUSES: EmailLogStatus[] = [
  "QUEUED",
  "SENT",
  "DELIVERED",
  "OPENED",
  "CLICKED",
  "BOUNCED",
  "DROPPED",
  "DEFERRED",
  "SPAM_REPORT",
  "FAILED",
];

export const EMAIL_LOG_REFERENCE_TYPES = [
  "OTP",
  "KYC",
  "TRANSACTION",
  "TRADE",
  "INVOICE",
  "SETTLEMENT",
];
